import { Col, Flex, Row } from 'antd';

import { Link } from '@suntex.core/nav';
import { Locale } from '@suntex.fim/enums';
import { getFlags } from '@suntex.fim/flags';
import { useFramework } from '@suntex.fim/framework';
import { ResourceList, handleKeyboardClick } from '@suntex.fim/ui';

import { rankingSections } from '../const';

const GRID_GUTTER_HORIZONTAL = 30;
const GRID_GUTTER_VERTICAL = 16;

export interface RankingsMenuProps {
  images?: {
    topTen?: string;
  };
}

export function RankingsMenu({ images }: RankingsMenuProps) {
  const { locale } = useFramework();

  const { top10: showTop10 } = getFlags().rankings;
  const isIndiaRegion = locale === Locale.IN;

  const shouldRenderLevel = (slug: string) => {
    if (slug.endsWith('-international') || slug.endsWith('-system')) {
      return isIndiaRegion;
    }
    return true;
  };

  return (
    <Flex vertical>
      {/* Ranking Sections */}
      <Row
        gutter={[GRID_GUTTER_HORIZONTAL, GRID_GUTTER_VERTICAL]}
        className="resources-column-wrapper"
      >
        {rankingSections.map((section) => (
          <Col xs={24} md={8} key={section.key} className="resources-column">
            <ResourceList
              title={section.title}
              resources={section.levels
                .filter(({ slug }) => shouldRenderLevel(slug))
                .map(({ slug, label }) => ({
                  title: label,
                  to: slug,
                  tabIndex: 0,
                  onKeyDown: handleKeyboardClick,
                  ariaLabel: `${label} ${section.title}`,
                }))}
            />
          </Col>
        ))}
      </Row>

      {/* Static Awards Link */}
      {showTop10 && (
        <div className="resources-item">
          {images?.topTen && (
            <Link
              to="https://explore.firstinmath.com/rankings/top-ten-awards?cc=us"
              className="text-body"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={images.topTen} alt="National Top 10 Awards" />
            </Link>
          )}
          <div className="resources-item__title fw-bold">
            <Link
              to="https://explore.firstinmath.com/rankings/top-ten-awards?cc=us"
              className="hover-underline-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              National Top 10 Awards
            </Link>
          </div>
        </div>
      )}
    </Flex>
  );
}
